export default __webpack_public_path__ + "static/media/text-about-us.5c3cf5fe.svg";